<template>
<v-card style="overflow-x:hidden;" >
  <v-row style="margin:0px!important;">
    <!-- PRIMERA TABLA -->
    <v-col cols="12" xs="12" sm="12" md="6" lg="6">
      <v-card-title>
        <div>
          <div>
            Productos
            <v-btn @click="InicializarArticulos" small text class="success mx-2"
              >Actualizar</v-btn
            >
          </div>
        </div>

        <v-divider dark class="ma-4" inline></v-divider>

        <v-text-field
          v-model="buscador"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        />
      </v-card-title>

      <v-data-table
        class="elevation-1 grey lighten-2 mx-auto"
        style="max-width:90%"
        :headers="columnasTabla1"
        :items="articulos"
        :search="buscador"
        :loading="cargando"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 20],
        }"
        :items-per-page="5"
      >
        <template v-slot:[`item.actionEditar`]="{ item }">
          <v-btn
            @click="AgregarArticulo(item)"
            small
            light
            class="amber lighten-2"
            style=""
          >
            Agregar
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <!-- TERMINA LA PRIMERA TABLA -->

    <v-divider vertical style="border-color: rgba(0, 0, 0, 0.42)"></v-divider>

    <!-- SEGUNDA TABLA -->
    <v-col cols="12" xs="12" sm="12" md="6" lg="6">
      <v-card-title >
        <span>Productos Agregados </span>

        <ModalExcel @EXCEL="archivoExcel" />
        <v-divider dark class="ma-4" inline></v-divider>

        <v-text-field
          v-model="buscador2"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        />
      </v-card-title>

      <v-data-table
        class="elevation-1 grey lighten-2 mx-auto"
        style="max-width:90%"
        :headers="columnasTabla2"
        :items="articulosAgregados"
        :search="buscador2"
        :items-per-page="5"
      >
        <template v-slot:[`item.AccionCantidad`]="{ item }">
          <v-text-field
            v-model="item.CANTIDAD"
            label="Cantidad"
            type="number"
            min="1"
          />
        </template>

        <template v-slot:[`item.AccionCosto`]="{ item }">
          <v-text-field
            v-model="item.COSTO"
            label="Costo"
            value="0.0"
            prefix="$"
            type="number"
            min="0"
          />
        </template>

        <template v-slot:[`item.AccionQuitar`]="{ item }">
          <v-btn
            @click="QuitarArticulo(item)"
            small
            text
            dark
            class="red darken-1"
          >
            Quitar
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
  <v-card-actions class="d-flex justify-space-around">
    <v-btn class="grey darken-2" dark @click="cerrarModal">Cancelar</v-btn>
    <v-btn class="primary darken-1" @click="asignarProductos">Agregar Productos</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import ModalExcel from "./ModalExcel.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: { ModalExcel },
  props:['infoProyecto'],
  data() {
    return {

      excel:null,
      cargando: false,

      buscador: "",
      buscador2: "",

      articulos: [],
      articulosAgregados: [],

      columnasTabla1: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        { text: "Producto", value: "NOMBRE", filterable:false },
        { text: "Accion", sortable: false, value: "actionEditar", align: "right", },
      ],
      columnasTabla2: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        { text: "Cantidad", sortable: false, value: "AccionCantidad", width: 100 / 5, },
        { text: "Producto", value: "NOMBRE" },
        { text: "Precio", sortable: false, value: "AccionCosto" },
        { text: "Accion", sortable: false, value: "AccionQuitar", align: "right",},
      ],
    };
  },

  computed: {
    ...mapGetters(["getURLAPI"]),
  },

  // ------------------------------------------------------------------------------
  methods: {
    AgregarArticulo(articulo) {
      if (!this.articulosAgregados.includes(articulo)) {
        this.articulosAgregados.push(articulo);
        console.log(this.articulosAgregados);
      }
    },

    // ------------------------------------------------------------------------------
    QuitarArticulo(articulo) {
      articulo.ARCHIVO = "";
      const index = this.articulosAgregados.indexOf(articulo);
      if (index > -1) {
        this.articulosAgregados.splice(index, 1);
      }
      console.log(this.articulosAgregados);
    },

    // ------------------------------------------------------------------------------
    async InicializarArticulos() {
      this.cargando = true;
      this.articulos = [];

      this.articulos = (
        await axios.get(`${this.getURLAPI}/Show/allArticles`)
      ).data;
      this.articulos.forEach((articulo) => {
        articulo.CANTIDAD = 1;
      });

      this.cargando = false;
    },

    archivoExcel( excel ) {
      this.excel = null;
      this.excel = excel;
    },

    // ------------------------------------------------------------------
    asignarProductos(){
      if ( this.excel != null && this.articulosAgregados.length > 0) {
        let datosForm = new FormData();
        datosForm.append("PROYECTO_ID", this.infoProyecto.PID);
        datosForm.append("FOLIO", this.infoProyecto.FOLIO);
        datosForm.append("PRODUCTOS", JSON.stringify(this.articulosAgregados));
        datosForm.append("EXCEL", this.excel);
        // console.log(JSON.stringify(this.articulosAgregados));
  
        axios.post(`${this.getURLAPI}/Proyecto/agregarProducto`, datosForm)
        .then( ({data}) =>{
          this.$root.vtoast.show(
            { message: data.MSG, color: data.STATUS=="OK" ? 'success darken-2':'red darken-2', 
              timer:10000, icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' } 
          )
          // console.log("entre a data");
        })
        .catch( () =>{
          this.$root.vtoast.show(
            { message: "Error al conectar con el servidor.", color: 'red darken-2', 
              timer:10000, icon: 'mdi-alert-circle-outline' } 
          )
        });
      } else {
        this.$root.vtoast.show(
            { message: "Ingresa articulos y/o archivo.", color: 'black', 
              timer:10000, icon: 'mdi-alert-circle-outline' } 
          )
      }
    },

    cerrarModal(){
      this.$emit('cerrarModal');
    }

    // log(){
    //   console.log(this.articulosAgregados);
    // },
  },

  created() {
    this.InicializarArticulos();
  },
};
</script>

<style></style>
